import {request, serviceUrl} from "@/utils/request";

// 获取所有的流程列表
export function actDeModelList() {
  return request({
    url: serviceUrl.activitiService + '/act/de/model/list'
  })
}

// 根据id查找model信息
export function findModelById(id) {
  return request({
    url: serviceUrl.activitiService + '/act/de/model/findById',
    params: {id}
  })
}

// 保存流程
export function saveProcess(data) {
  return request({
    url: serviceUrl.activitiService + '/act/de/model/add',
    method: 'post',
    data: data
  })
}

// 根据pid获取流程图xml
export function getXmlById(id) {
  return request({
    url: serviceUrl.activitiService + '/act/de/model/getXmlById',
    params: {id}
  })
}

